import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { DynamicPageRoutingModule } from './dynamic-routing.module';
import { DynamicPage } from './dynamic.page';

@NgModule({
  imports: [CommonModule, RouterModule, IonicModule, DynamicPageRoutingModule],
  declarations: [DynamicPage],
})
export class DynamicPageModule {}
